import React from 'react';
import classNames from 'classnames';
import { Button } from '../../Button';
import { RemoveOutline } from '../../../foundations/icons';
import styles from './Clear.module.scss';
var Clear = function (_a) {
    var _b;
    var hidden = _a.hidden, onClick = _a.onClick;
    return (React.createElement(Button, { "aria-label": "Clear search", className: classNames(styles.button, (_b = {},
            _b[styles.hidden] = hidden,
            _b)), "data-actiontype": "search", "data-origincomponent": "SearchForm", "data-shortdescription": "clear search", onClick: onClick, startIcon: React.createElement(RemoveOutline, { size: "small" }), theme: "primaryWhite" }));
};
Clear.displayName = 'Clear';
export { Clear };
//# sourceMappingURL=Clear.js.map